import { MEMBERSHIP_SEASON } from '../config/membershipSeason';

/** Saisons où l'admin indique qu'un membre est actif (aligné backend). */
export const MEMBER_ACTIVE_SEASONS = ['2024-2025', '2025-2026', '2026-2027'];

function sortActiveSeasonsList(arr) {
  if (!Array.isArray(arr)) return [];
  const set = new Set(arr.filter((s) => MEMBER_ACTIVE_SEASONS.includes(s)));
  return MEMBER_ACTIVE_SEASONS.filter((s) => set.has(s));
}

/** Saisons actives ; repli sur `season` (CRM) si `activeSeasons` est vide (anciens comptes). */
export function getActiveSeasonsFromUser(user) {
  if (!user) return [];
  const fromDb = Array.isArray(user.activeSeasons) ? user.activeSeasons : [];
  if (fromDb.length > 0) return sortActiveSeasonsList(fromDb);
  if (user.season && MEMBER_ACTIVE_SEASONS.includes(user.season)) {
    return sortActiveSeasonsList([user.season]);
  }
  return [];
}

export function formatActiveSeasonsCell(user) {
  const sorted = getActiveSeasonsFromUser(user);
  return sorted.length ? sorted.join(', ') : '—';
}

/** Membre actif pour une saison : `isMember` + saison cochée. Les admins sont exemptés. */
export function isActiveMemberForSeason(user, season = MEMBERSHIP_SEASON) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (typeof user.isActiveForCurrentSeason === 'boolean' && season === MEMBERSHIP_SEASON) {
    return user.isActiveForCurrentSeason;
  }
  if (!user.isMember) return false;
  return getActiveSeasonsFromUser(user).includes(season);
}
